'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const contentItems = [
{
  id: 'content-001',
  creator: 'Yasmine Belkacem',
  brand: 'L\'Oréal Paris',
  category: 'Beauty',
  format: 'Reel',
  views: '1.2M',
  engagement: '9.4%',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_143d8d248-1772053903298.png",
  thumbAlt: 'Beauty product showcase with warm lighting, cosmetics reel thumbnail',
  duration: '0:28'
},
{
  id: 'content-002',
  creator: 'Karim Oussedik',
  brand: 'TECNO Mobile',
  category: 'Tech',
  format: 'Reel',
  views: '847K',
  engagement: '7.1%',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_11944d436-1772297025398.png",
  thumbAlt: 'Smartphone product review setup with clean background, tech content',
  duration: '0:45'
},
{
  id: 'content-003',
  creator: 'Sarah Hamdi',
  brand: 'Yassir',
  category: 'Lifestyle',
  format: 'Story Series',
  views: '320K',
  engagement: '12.3%',
  thumbnail: "https://images.unsplash.com/photo-1668437790563-4e0187cf721c",
  thumbAlt: 'Lifestyle content in Algerian urban setting, natural colors',
  duration: '1:12'
},
{
  id: 'content-004',
  creator: 'Lina Meziane',
  brand: 'Maybelline',
  category: 'Beauty',
  format: 'TikTok',
  views: '2.1M',
  engagement: '11.8%',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_111eb1d74-1772488273488.png",
  thumbAlt: 'Makeup transformation video thumbnail, bold colors',
  duration: '0:15'
},
{
  id: 'content-005',
  creator: 'Sofiane Rahmani',
  brand: 'Coca-Cola Algérie',
  category: 'Food',
  format: 'Reel',
  views: '560K',
  engagement: '8.6%',
  thumbnail: "https://images.unsplash.com/photo-1730698297019-49d86fdc89b0",
  thumbAlt: 'Food styling with colorful dishes, recipe content thumbnail',
  duration: '0:32'
},
{
  id: 'content-006',
  creator: 'Nadia Cherif',
  brand: 'Samsung',
  category: 'Fashion',
  format: 'Reel',
  views: '934K',
  engagement: '6.9%',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_15d62ad32-1768272572229.png",
  thumbAlt: 'Fashion lookbook with stylish outfits, vibrant colors',
  duration: '0:22'
},
{
  id: 'content-007',
  creator: 'Amel Bensalem',
  brand: 'Garnier',
  category: 'Beauty',
  format: 'UGC',
  views: '410K',
  engagement: '13.2%',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_146247ef4-1772484895633.png",
  thumbAlt: 'Natural skincare product review in bright bathroom setting',
  duration: '0:18'
},
{
  id: 'content-008',
  creator: 'Rania Touati',
  brand: 'Djezzy',
  category: 'Lifestyle',
  format: 'Reel',
  views: '678K',
  engagement: '7.8%',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1a447eed6-1772313152055.png",
  thumbAlt: 'Young woman in Algerian city setting, lifestyle brand content',
  duration: '0:25'
}];


export default function BestPerformingContent() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-lg font-700 text-foreground">Best Performing Content</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Contenus les plus performants des 30 derniers jours</p>
        </div>
        <Link href="/find-a-creator" className="text-sm font-500 text-primary hover:text-primary/80 transition-colors">
          Voir tout →
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {contentItems?.map((item) =>
        <div
          key={item?.id}
          className="relative rounded-xl overflow-hidden cursor-pointer group"
          onMouseEnter={() => setHoveredId(item?.id)}
          onMouseLeave={() => setHoveredId(null)}>
          
            <div className="aspect-[3/4] relative">
              <AppImage
              src={item?.thumbnail}
              alt={item?.thumbAlt}
              fill
              className="object-cover group-hover:scale-105 transition-transform duration-300" />
            
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent" />

              {/* Duration */}
              <div className="absolute top-2 right-2 bg-black/60 rounded px-1.5 py-0.5">
                <span className="text-xs text-white font-mono">{item?.duration}</span>
              </div>

              {/* Format badge */}
              <div className="absolute top-2 left-2 bg-primary/80 rounded px-1.5 py-0.5">
                <span className="text-xs text-white font-600">{item?.format}</span>
              </div>

              {/* Play button on hover */}
              {hoveredId === item?.id &&
            <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                  <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center">
                    <Icon name="PlayIcon" size={18} className="text-background ml-0.5" />
                  </div>
                </div>
            }

              {/* Bottom info */}
              <div className="absolute bottom-0 left-0 right-0 p-2">
                <p className="text-xs font-600 text-white line-clamp-1">{item?.creator}</p>
                <p className="text-xs text-white/70">{item?.brand}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs font-700 text-white font-mono">{item?.views}</span>
                  <span className="text-xs text-positive font-600">{item?.engagement}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>);

}